import { render, staticRenderFns } from "./form-input-numeric.vue?vue&type=template&id=32b48a5c&"
import script from "./form-input-numeric.vue?vue&type=script&lang=js&"
export * from "./form-input-numeric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports